module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/pierata.dc37679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/pierata.jpg
// module id = DneE
// module chunks = 0